import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesGaleria {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
  excluir: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `storage`
 * (`apps/api/src/modules/storage/storage.routes.ts`, seed original da
 * migration `004`): `admin` (curinga `*`) tem tudo; `producao` e
 * `marketing` têm `ler`+`criar` (fotos de OPS / mídia de campanha,
 * `PRODUCT.md` 4.3/4.6) — nenhum dos dois pode editar metadado ou
 * excluir arquivo de outro módulo.
 */
export function permissoesGaleria(papel: PapelUsuario): PermissoesGaleria {
  if (papel === 'admin') return { ler: true, criar: true, atualizar: true, excluir: true };
  if (papel === 'producao' || papel === 'marketing') {
    return { ler: true, criar: true, atualizar: false, excluir: false };
  }
  return { ler: false, criar: false, atualizar: false, excluir: false };
}
